import { LayerAlias, UnitTypes } from "constant";
import { MapProvider } from "../ApiServiceProviders";

export const getProjectUnits = async ({ params }) => {
  return MapProvider.client
    .get(
      `/projects/${params.projectId}/units?limit=${
        params.limit ?? 99999999
      }&skip=${params.skip ?? 0}&type=${params.type}${
        params.provider ? `&provider_id=${params.provider}` : ""
      }`
    )
    .then((response) => response)
    .catch((error) => error.response);
};

export const downloadImage = async ({ params, fields }) => {
  return MapProvider.client.post(
    `/projects/${params.projectId}/layers/${params.alias}/images/download`,
    fields
  );
};

export const getProviderPhotos = async ({ params }) => {
  return MapProvider.client.get(
    `/projects/${params.projectId}/layers/${params.alias}/images?limit=${
      params.limit ?? 99999999
    }&skip=${params.skip ?? 0}${
      params.provider ? `&provider_id=${params.provider}` : ""
    }`
  );
};

export const getUnits = async ({ params }) => {
  if (params.type === UnitTypes.PHOTO)
    return getProviderPhotos({ params })
      .then((response) => {
        return {
          ...response,
          data: {
            ...response.data,
            units: response.data.images,
            images: undefined
          }
        };
      })
      .catch((error) => error.response);

  return MapProvider.client
    .get(
      `/projects/${params.projectId}/layers/${params.alias}/units?limit=${
        params.limit ?? 99999999
      }&skip=${params.skip ?? 0}&type=${params.type}${
        params.provider ? `&provider_id=${params.provider}` : ""
      }`
    )
    .then((response) => response)
    .catch((error) => error.response);
};

export const getUnit = async ({ params }) => {
  return MapProvider.client
    .get(
      `/projects/${params.projectId}/layers/${params.alias}/units/${params.id}`
    )
    .then((response) => response)
    .catch((error) => error.response);
};

export const addUnit = async ({ params, fields }) => {
  return MapProvider.client
    .post(
      `/projects/${params.projectId}/layers/${LayerAlias.MANUAL}/units`,
      fields
    )
    .then((response) => response)
    .catch((error) => error.response);
};

export const putUnit = async ({ params, fields }) => {
  return MapProvider.client
    .put(
      `/projects/${params.projectId}/layers/${params.alias}/units/${params.unitId}`,
      fields
    )
    .then((response) => response)
    .catch((error) => error.response);
};

export const removeUnit = async ({ params }) => {
  return MapProvider.client
    .delete(
      `/projects/${params.projectId}/layers/${params.alias}/units/${params.unitId}`
    )
    .then((response) => response)
    .catch((error) => error.response);
};

export const getUnitsClassifications = async () => {
  return MapProvider.client
    .get(`/units/classification`)
    .then((response) => response)
    .catch((error) => error.response);
};

export const putPointTrainingClassification = async ({ params, fields }) => {
  return MapProvider.client
    .put(
      `/projects/${params.projectId}/layers/${params.alias}/units/${params.unitId}/classify/training`,
      fields
    )
    .then((response) => response)
    .catch((error) => error.response);
};

export const downloadPointsExcel = async ({ params }) => {
  return MapProvider.clientBlob
    .post(
      `/projects/${params.projectId}/excel`,
      {},
      {
        params: {
          "classification_type[]": params.classification_type
        }
      }
    )
    .then((response) => response)
    .catch((error) => error.response);
};
